import React, {createRef} from 'react'
import PropTypes from 'prop-types'

import MentionsManager from "src/core/gd/manager/mentions-manager"
import DocumentViewPages from "./pages/pages"
import AttachmentsManager from "src/core/gd-components/files/attachments-manager/attachments-manager"
// import RichTextEditor from "core/gd-components/rich-editor/rich-editor"
import RichTextEditorUniversal from "../../../../core/gd-components/editor-universal/editor-universal"
import OrganizationSettingsManager from "src/core/gd/manager/organization-settings-manager"
import NoteViewPageTitle from "./page-title"
import LeftControls from "./controls/left-controls"
import RightControls from "./controls/right-controls"
import {AttachFileMode} from "../../../../core/gd-components/files/const";

const debug = false
// const debug = "DocumentViewContent"

export default class DocumentViewContent extends React.Component {

    static propTypes = {
        parent                  : PropTypes.object,
        document                : PropTypes.object,
        pageId                  : PropTypes.string,  // main data source

        revisionId              : PropTypes.string,

        dropzoneDOMElementId    : PropTypes.string,

        noRevision              : PropTypes.bool,
        editable                : PropTypes.bool,

        onChange                : PropTypes.func,   // called when page updated to show submit button
        onChangeAccess          : PropTypes.func,
        onSave                  : PropTypes.func,
        onAddPage               : PropTypes.func,
        onRemovePage            : PropTypes.func,
        onClickPage             : PropTypes.func,
        onEscape                : PropTypes.func
    }

    constructor(props) {
        super(props)

        this.refAttachmentManager   = createRef()
        this.refTextarea            = createRef()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.parent.autoEditTitle && this.title) {
            this.props.parent.autoEditTitle = false
            this.title.onEditClick()
        }
    }

    getPrintContainer = () => {
        this.refTextarea.current.getPrintContainer()
    }

    onNewPage = (e) => this.pages.onNewPage(e)

    // MESSAGE CHANGES

    onMessageChange = (message, messageRTF) => {
        debug && console.log(debug, "onMessageChange", message, messageRTF)

        const page      = this.props.document.pages.getPage(this.props.pageId)
        page.content    = message
        page.contentRTF = messageRTF

        this.props.parent.onPageChange()

        if (this.refAttachmentManager.current) this.refAttachmentManager.current.onMessageRTFChanged(messageRTF)
    }

    onTitleChange = () => {
        this.props.parent.onPageChange()
        this.pages.update()
    }

    // ATTACHMENTS

    pasteImage = (file) => {
        this.refAttachmentManager.current.pasteImage(file)
    }

    // select new file clicked...
    onAttachmentSelect = (value) => {
        this.refAttachmentManager.current.selectAttachment(value)
    }

    // add attachment(s) to message
    onAddToMessage = (data /*attachment or array of attachments*/) => {
        debug && console.log(debug, "onAddToMessage", data)

        if (Array.isArray(data))    this.refTextarea.current.addAttachmentsToEditor(data)
        else                        this.refTextarea.current.addAttachmentToEditor(data)
    }

    onNewAttachment = (attachment) => {
        debug && console.log(debug, "onNewAttachment", attachment)

        this.props.parent.onPageChange()

        // auto add to editor

        // aga - super hitrii hack
        // t.k. v notes attachments vsegda vnutri nam nuzno ukazat' special
        // render mode dlya attachments
        attachment.renderMode           = 'notes-edit'
        attachment.refAttachmentManager = this.refAttachmentManager

        // AttachmentManager autoAddToMessage is enabled no need to add manually
        // this.onAddToMessage(attachment)
    }

    onRemoveAttachment = (attachment) => {
        this.props.parent.onPageChange()
    }

    render() {
        const showPagesList     = this.props.document.pages.length > 1
        const showAttachments   = OrganizationSettingsManager.isAttachmentsEnabled()
        const canEdit           = !!this.props.editable && !this.props.revisionId

        const classes = Classes("iv-content", "content", this.props.className, {
            'with-pages-list'   : showPagesList,
            'editable'          : canEdit
        })

        const page          = this.props.document.pages.getPage(this.props.pageId)

        debug && console.log(debug, "render", canEdit, this.props.pageId, page, this.props.document.pages)

        page.prepareAttachments(this.refAttachmentManager, canEdit)

        const controlsParams = {
            leftChildren    : <LeftControls onNewPage={this.onNewPage}/>,
            rightChildren   : <RightControls parent = {this.props.parent}
                                             onSave = {this.props.onSave}/>
        }

        return (
            <div className={classes}>
                <DocumentViewPages ref              = {r=>this.pages = r}
                                   pages            = {this.props.document.pages}
                                   currentPageId    = {this.props.pageId}
                                   disabled         = {!this.props.editable || !!this.props.revisionId}
                                   onAdd            = {this.props.onAddPage}
                                   onRemove         = {this.props.onRemovePage}
                                   onClick          = {this.props.onClickPage}/>

                {showPagesList &&
                    <NoteViewPageTitle ref          = {r=>this.title = r}
                                       revisionId   = {this.props.revisionId}
                                       page         = {page}
                                       editable     = {this.props.editable}
                                       onChange     = {this.onTitleChange} />}

                <RichTextEditorUniversal ref                        = {this.refTextarea}
                                         key                        = {'{0}_{1}_{2}'.f(this.props.revisionId, this.props.pageId, this.props.document.historyCount)}
                                         className                  = "gd-textarea-rte note-content-editor size-normal"
                                         showControls               = {true}
                                         controlsParams             = {controlsParams}
                                         showSettingsButton         = {false}
                                         hideControlsAllowed        = {false}
                                         localSettingsName          = "note-editor.settings"
                                         attachmentsCollection      = {page.attachmentsCollection}
                                         placeholder                = "Type text here..."
                                         editable                   = {canEdit}
                                         // forceComponentsOfViewType  = {true}
                                         focusOnMount               = {false}
                                         projectId                  = {this.props.document.projectId}
                                         mentions                   = {MentionsManager.getMentions({projectId: this.props.document.projectId})}
                                         stateSaveInterval          = {0}
                                         messageText                = {page.content}
                                         messageRTF                 = {page.contentRTF}
                                         onEscape                   = {this.props.onEscape}
                                         onChange                   = {this.onMessageChange}
                                         onPasteImage               = {this.pasteImage}
                                         onAddAttachment            = {this.onAttachmentSelect}/>

                {/*<RichTextEditor ref                         = {this.refTextarea}
                                key                         = {'{0}_{1}_{2}'.f(this.props.revisionId, this.props.pageId, this.props.document.historyCount)}
                                className                   = "gd-textarea-rte note-content-editor size-normal"
                                showControls                = {true}
                                controlsParams              = {controlsParams}
                                showSettingsButton          = {false}
                                hideControlsAllowed         = {false}
                                localSettingsName           = "note-editor.settings"
                                attachmentsCollection       = {page.attachmentsCollection}
                                placeholder                 = "Type text here..."
                                editable                    = {this.props.editable && !this.props.revisionId}
                                forceComponentsOfViewType   = {true}
                                focusOnMount                = {false}
                                companyId                   = {gd.companyId}
                                projectId                   = {this.props.document.projectId}
                                mentions                    = {MentionsManager.getMentions({projectId: this.props.document.projectId})}
                                stateSaveInterval           = {0}
                                text                        = {page.content}
                                rtfState                    = {page.contentRTF}
                                type                        = {this.props.editable ? "full" : "view"}
                                onEscape                    = {this.props.onEscape}
                                onChange                    = {this.onMessageChange}
                                onPasteImage                = {this.pasteImage}
                                onAddAttachment             = {this.onAttachmentSelect}/>*/}

                {showAttachments && this.props.dropzoneDOMElementId &&
                    <AttachmentsManager ref                     = {this.refAttachmentManager}
                                        attachmentsCollection   = {page.attachmentsCollection}
                                        mode                    = {AttachFileMode.EDIT}
                                        dropzoneDOMElementId    = {this.props.dropzoneDOMElementId}
                                        autoAddToMessage        = {true}
                                        saveNewUpload           = {this.onNewAttachment}
                                        saveRemoveFile          = {this.onRemoveAttachment}
                                        onAddToMessage          = {this.onAddToMessage}/>}
            </div>
        );
    }
}
